import { Button } from "reactstrap";
import { BtnProps } from "../../Types/CommonElementType";

const Btn:React.FC<BtnProps> = (props) => {
  return <Button {...props}>{props.children}</Button>;
};

export default Btn;
